import { render, staticRenderFns } from "./TeacherClassroom.vue?vue&type=template&id=7c67cd6c&"
import script from "./TeacherClassroom.vue?vue&type=script&lang=js&"
export * from "./TeacherClassroom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports